import api from '@/services/api'
import { METHOD, request} from '@/utils/request'

export const dataApi = {
    getDetail(id) {//获取详情
        return request(api.visit.DETAIL + "/" + id, METHOD.GET);
    },
    async selection(params) {
        // return request(api.client.SELECTION, METHOD.GET, params)
        return request(api.visit.SELECT_DEPT, METHOD.GET, params)
    }
}


export default {dataApi}
